export default "__VITE_ASSET__7qohUWJV__"